import { render, staticRenderFns } from "./ReturnServiceDetail.vue?vue&type=template&id=06f7c8b1&scoped=true"
import script from "./ReturnServiceDetail.vue?vue&type=script&lang=js"
export * from "./ReturnServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ReturnServiceDetail.vue?vue&type=style&index=0&id=06f7c8b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7c8b1",
  null
  
)

export default component.exports